import useCart from "./useCart";
import useProducts from "./useProducts";

export const percentages = {
    'dentaire': 40,
    'kine': 40,
    'sante-mentale': 60,
    'pharma': 50,
    'medecine': 40,
    'infirmiere': 40,
    'default': 50
}

export default function useFifplFunding(){

    const { cart } = useCart();

    const cat = cart.category || 'default';

    const products = useProducts();

    const product = products.isSuccess ? products.data.find(p => p.variant.id === 'fifpl') : null;

    const price = product?.price || 0;

    const refundPercentage = percentages[cat] || 50;

    const restPercentage = 100 - refundPercentage;

    /**
     * Spécificité de la filière Kiné : plafond de remboursement à 200€
     * Ticket Notion :
     * https://www.notion.so/learnylib/Changer-la-description-dans-le-mode-de-financement-dc779701bc6c43a4847118aa15299143
     */
    if (cart.category === 'kine') {
        return {
            percentage: price === 0 ? 0 : Math.round(200 / price * 100),
            price: price,
            refund: 200, // Remboursé
            rest: price - 200 // Reste à charge
        }
    }

    return {
        percentage: refundPercentage,
        price: price,
        refund: Math.round(refundPercentage / 100 * price), // Remboursé
        rest: Math.round(restPercentage / 100 * price) // Reste à charge
    }

}